var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSilverZakautChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.4 19.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #4f505e;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #40a87f;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-4 {\r\n        isolation: isolate;\r\n        opacity: .4;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1358",
    "data-name": "Group 1358",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "cls-1",
    d: "M13.4,14.5c-1.6,1.3-4.8-.2-7.3-3.3s-2-7.7-2-7.7c0,0,4.8.2,7.3,3.3,2.6,3,3.6,6.4,2,7.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    className: "cls-1",
    d: "M12.2,15c2.1,0,3.5-3.2,3.5-7.2S12.2.7,12.2.7c0,0-3.5,3.2-3.5,7.2s1.4,7.2,3.5,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    className: "cls-1",
    d: "M11,14.5c1.6,1.3,4.8-.2,7.3-3.3,2.6-3,2-7.7,2-7.7,0,0-4.8.2-7.3,3.3-2.6,3-3.6,6.4-2,7.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    className: "cls-1",
    d: "M8.7,7.8c0-1,.2-1.9.6-2.8.8.5,1.6,1,2.2,1.8,2.6,3,3.6,6.4,2,7.7-.4.3-.8.5-1.3.5-2.1-.1-3.4-3.3-3.4-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    className: "cls-1",
    d: "M15.7,7.8c0-1-.2-1.9-.6-2.8-.8.5-1.6,1-2.2,1.8-2.6,3-3.6,6.4-2,7.7.4.3.8.5,1.3.5,2.1-.1,3.4-3.3,3.4-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    className: "cls-1",
    d: "M12.2,18.1l-1.5-3.9c-1-1.3-.4-3.9,1.5-6.4,1.8,2.5,2.5,5.1,1.5,6.4l-1.5,3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-7",
    className: "cls-1",
    d: "M12.2,18.2c0-2.3,1.4-5,4.1-6.8s5.7-2.3,7.9-1.5c-2.5.3-4.9,1.3-7,2.8-2.1,1.4-3.9,3.3-5,5.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-8",
    className: "cls-1",
    d: "M12.2,18.2c0-2.3-1.4-5-4.1-6.8S2.3,9,.2,9.9c2.5.3,4.9,1.3,7,2.8,2.1,1.4,3.9,3.3,5,5.5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "check"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.1,19c-.4,0-.7-.1-1-.4l-3.3-3.3c-.4-.4-.5-.9-.4-1.4.1-.5.5-.9,1-1,.1,0,.2,0,.4,0,.4,0,.8.2,1,.4l2.2,2.2,3.3-4.2h-.2l.9-.9c.3-.3.6-.4,1-.4s.7.1,1,.4c.5.5.6,1.4,0,2l-4.9,6.1h0s0,0,0,0c-.3.3-.6.4-1,.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M12,10.5c-.2,0-.5,0-.6.3h0s0,0,0,0l-4.3,5.5-2.6-2.6c-.2-.2-.6-.3-.9-.3-.3,0-.6.3-.7.7,0,.3,0,.7.3.9l3.3,3.3c.2.2.4.3.7.3.3,0,.5-.1.7-.3l4.9-6.2c.3-.4.3-.9,0-1.3-.2-.2-.4-.3-.6-.3M12,9.5c.5,0,1,.2,1.3.6.7.7.8,1.9,0,2.6l-4.9,6.2h0c-.4.4-.9.6-1.4.6,0,0,0,0,0,0-.5,0-1-.2-1.4-.6l-3.3-3.3c-.5-.5-.7-1.2-.5-1.9.2-.7.7-1.2,1.4-1.4.2,0,.3,0,.5,0,.5,0,1,.2,1.4.6l1.8,1.8,2.3-3,1.4-1.7c.4-.3.8-.5,1.3-.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverZakautChecked);
export default __webpack_public_path__ + "static/media/silverZakautChecked.a83c0a85aaaff5ac8fc241e38f1c9f29.svg";
export { ForwardRef as ReactComponent };